module.exports = __webpack_public_path__ + "media/images/elms-3642e87e160d600c0af20e61e1272d65.jpg";